import React from "react";
import styles from "./FormFieldInputNew.module.scss";
import classNames from "classnames";

const FormFieldInputButton = ({Icon, label, className, style, children, ...rest}) => {
    return <button type="button" className={classNames(styles["form-field-input-button"], className)} style={style} {...rest}>
        {Icon && <Icon/>}
        {label && <span className={styles["label"]}>{label}</span>}
        {children}
    </button>
}

export default FormFieldInputButton;
